
import React from 'react';
import Layout from '@/components/layout/Layout';
import ProcurementOverview from './ProcurementOverview';

const Procurement = () => {
  return (
    <Layout>
      <ProcurementOverview />
    </Layout>
  );
};

export default Procurement;
